import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_PATH } from './constants';
import { DEFAULT_EMPLOYMENT, DEFAULT_EMPLOYMENTS_RESPONSE } from './fixtures';

export const employmentsHandlers = [
  http.get(`*${API_PATH}?userId=:userId&display=lspName`, () =>
    HttpResponse.json(DEFAULT_EMPLOYMENTS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}?userId=:userId`, () =>
    HttpResponse.json(DEFAULT_EMPLOYMENTS_RESPONSE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.get(`*${API_PATH}/:id`, () =>
    HttpResponse.json(DEFAULT_EMPLOYMENT, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*${API_PATH}`, () =>
    HttpResponse.json(DEFAULT_EMPLOYMENT, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.patch(`*${API_PATH}/:id`, () =>
    HttpResponse.json(DEFAULT_EMPLOYMENT, {
      status: HTTPStatusCodes.OK,
    }),
  ),
];
